import React, { useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import {
  getIsBrVerified,
  getVerifyingBr,
  verifyAndFetchingBrokerAgainstResponse,
} from "../store/redit";
import Loader3Orange from "./Loader3Orange";
import UnauthorizedAccess from "./UnauthorizedAccess";

const AuthFetchBrokerResponse = (props) => {
  const { responseid, possibleApiStatusValue } = props;

  const isbrVerified = useSelector(getIsBrVerified);
  const verifyingBr = useSelector(getVerifyingBr);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(
      verifyAndFetchingBrokerAgainstResponse({
        responseid,
      })
    );
  }, [dispatch, responseid]);

  return (
    <React.Fragment>
      {verifyingBr ||
      possibleApiStatusValue === PossibleApiStatusValues.loading ? (
        <div>
          <Loader3Orange></Loader3Orange>
        </div>
      ) : isbrVerified ? (
        props.children
      ) : (
        <UnauthorizedAccess></UnauthorizedAccess>
      )}
    </React.Fragment>
  );
};

export default AuthFetchBrokerResponse;
